import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useConvexAuth } from "@convex-dev/auth/react"
import './index.css'
import { ConvexReactClient } from 'convex/react'
import { ConvexAuthProvider } from "@convex-dev/auth/react"
import Landing from './pages/Landing'
import NewEvent from './pages/events/NewEvent'
import Dashboard from './pages/dashboard/Dashboard'
import EventDashboard from './pages/dashboard/EventDashboard'
import CheckIn from './pages/checkin/CheckIn'
import PhotographerDashboard from './pages/photographer/PhotographerDashboard'
import GoogleCallback from './pages/auth/GoogleCallback'
import Gallery from './pages/gallery/Gallery'
import Checkout from './pages/checkout/Checkout'
import SuperadminDashboard from './pages/admin/SuperadminDashboard'
import AdminLogin from './pages/admin/AdminLogin'
import NotFound from './pages/NotFound'

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string)

// Protected route untuk Superadmin (hanya admin)
function SuperadminProtected({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useConvexAuth();
  const adminEmail = localStorage.getItem("fotomomen_admin_email");
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-indigo-600 border-t-transparent"></div>
      </div>
    );
  }
  
  // Guard via Convex Auth atau admin session lokal
  if (!isAuthenticated && !adminEmail) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return <>{children}</>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConvexAuthProvider client={convex}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/events/new" element={<NewEvent />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/:eventSlug" element={<EventDashboard />} />
          <Route path="/checkin/:eventSlug" element={<CheckIn />} />
          <Route path="/photographer/:eventId" element={<PhotographerDashboard />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/gallery/:guestId" element={<Gallery />} />
          <Route path="/checkout/:eventId" element={<Checkout />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          {/* Aliases for admin login */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/login" element={<Navigate to="/admin/login" replace />} />
          <Route path="/loginadmin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/adminlogin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/dashboard" element={<Navigate to="/superadmin" replace />} />

          {/* Aliases for common user routes */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/events" element={<Navigate to="/dashboard" replace />} />
          <Route path="/event/new" element={<Navigate to="/events/new" replace />} />

          <Route 
            path="/superadmin" 
            element={
              <SuperadminProtected>
                <SuperadminDashboard />
              </SuperadminProtected>
            } 
          />

          {/* Catch-all 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ConvexAuthProvider>
  </StrictMode>,
)